import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["data-key"]

import { type PropType, ref } from "vue";
import {
    type MappedProductCollectionModel,
    type ProductCollectionModel,
} from "../../models";
import { type IsCheckedMethod, type SetCheckedMethod } from "./types";
import { getCollectionUrl } from "../../collection-url";
import labels from "../../../../shared/labels";
import CheckboxItem from "../common/checkbox-item.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'sub-items',
  props: {
    collection: {
        type: Object as PropType<MappedProductCollectionModel>,
        required: true,
    },
    debugProductCounts: Boolean,
    collections: {
        type: Array as PropType<MappedProductCollectionModel[]>,
        required: true,
    },
    items: {
        type: Array as PropType<
            {
                subCollection: MappedProductCollectionModel;
                i: number;
                depth: number;
            }[]
        >,
        required: true,
    },
    parentDepth: {
        type: Number,
        required: true,
    },
    setChecked: {
        type: Function as PropType<SetCheckedMethod>,
        required: true,
    },

    isChecked: {
        type: Function as PropType<IsCheckedMethod>,
        required: true,
    },
    viewMode: {
        type: Number,
        required: true,
    },
    baseUrl: String,
    value: Array as PropType<number[][]>,
    root: {
        type: Array as PropType<MappedProductCollectionModel[]>,
        required: true,
    },
    matchedLogicalName: String,
    matchedLogicalNameEntityGuid: Number,
    matchedLogicalNameModuleGuid: Number,
    matchedLogicalNameSubModuleGuid: Number,
},
  setup(__props) {

const props = __props;

function getName(col: MappedProductCollectionModel) {
    if (col.Filler) return undefined;
    let name = col.Name;

    if (props.debugProductCounts) {
        name += ` ${col.ProductCount}`;
    }
    return name;
}

const limitSubItems = ref(8);
const unlimitSubItemsForCollectionId = ref<number[]>([]);

function shouldShowItem(
    subCollection: ProductCollectionModel,
    collection: ProductCollectionModel,
    i: number,
    collections: ProductCollectionModel[],
    value: number[][] | null | undefined
) {
    const limit = getLimitForCollection(collection);
    const isBetweenLimit = limit <= 0 || i < limit;
    const checked = props.isChecked(
        value,
        collections.indexOf(collection),
        subCollection.Id
    );

    if (subCollection.ProductCount === 0 && !checked) return false;

    return isBetweenLimit || checked;
}

function getLimitForCollection(collection: ProductCollectionModel) {
    if (isUnlimited(collection)) {
        return 0;
    }
    return limitSubItems.value;
}

function applyShowAll(collection: ProductCollectionModel) {
    if (!isUnlimited(collection)) {
        unlimitSubItemsForCollectionId.value.push(collection.Id);
    }
}
function stopShowAll(collection: ProductCollectionModel) {
    while (isUnlimited(collection)) {
        const index = unlimitSubItemsForCollectionId.value.indexOf(
            collection.Id
        );
        unlimitSubItemsForCollectionId.value.splice(index, 1);
    }
}
function isUnlimited(collection: ProductCollectionModel) {
    if (collection.Settings?.alwaysExpanded == true) return true;
    return unlimitSubItemsForCollectionId.value.includes(collection.Id);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_TransitionGroup, {
    tag: "div",
    class: _normalizeClass(_ctx.$style['sub-items']),
    "enter-class": _ctx.$style['sub-item-transition-enter'],
    "leave-to-class": _ctx.$style['sub-item-transition-leave-to'],
    "leave-active-class": _ctx.$style['sub-item-transition-leave-active']
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, ({ subCollection, i, depth }) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (
                    shouldShowItem(
                        subCollection,
                        __props.collection,
                        i,
                        __props.collections,
                        __props.value
                    )
                )
            ? _withDirectives((_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(['sub-item-depth-' + (depth - (__props.parentDepth - 1))]),
                key: subCollection.Id,
                "data-key": subCollection.Id
              }, [
                _createCommentVNode(" TODO: common/checkbox-item.vue "),
                _createVNode(CheckboxItem, {
                  id: 'collectionCheckBox_' + subCollection.Id,
                  href: 
                        subCollection.Filler === true
                            ? '#'
                            : _unref(getCollectionUrl)(
                                  subCollection,
                                  __props.viewMode,
                                  __props.baseUrl,
                                  __props.value,
                                  __props.root ?? [],
                                  __props.matchedLogicalName,
                                  __props.matchedLogicalNameEntityGuid,
                                  __props.matchedLogicalNameModuleGuid,
                                  __props.matchedLogicalNameSubModuleGuid
                              ) ?? '#'
                    ,
                  checked: 
                        __props.isChecked(
                            __props.value,
                            __props.collections.indexOf(__props.collection),
                            subCollection.Id
                        )
                    ,
                  name: getName(subCollection),
                  onSelect: ($event: any) => (
                        __props.setChecked(
                            __props.collections.indexOf(__props.collection),
                            subCollection.Id,
                            $event,
                            depth - (__props.parentDepth - 1)
                        )
                    )
                }, null, 8 /* PROPS */, ["id", "href", "checked", "name", "onSelect"]),
                _createCommentVNode("<span :class=\"$style['product-count']\" v-if=\"subCollection.hasOwnProperty('ProductCount')\">({{subCollection.ProductCount}})</span>")
              ], 10 /* CLASS, PROPS */, _hoisted_1)), [
                [_vShow, 
                    subCollection.Settings == null ||
                    subCollection.Settings.invisibleOnFilters == false
                ]
              ])
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
      }), 256 /* UNKEYED_FRAGMENT */)),
      (
                __props.items.filter((x) => x.subCollection.ProductCount !== 0).length >
                limitSubItems.value
            )
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!isUnlimited(__props.collection))
              ? _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(_ctx.$style['show-more']),
                  key: "show-all",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (applyShowAll(__props.collection)))
                }, _toDisplayString(_unref(labels).get(
                        "frontendProductList.filters.productCollection.showMore"
                    )), 3 /* TEXT, CLASS */)), [
                  [_vShow, 
                    __props.collection.Settings == null ||
                    __props.collection.Settings.invisibleOnFilters == false
                ]
                ])
              : _createCommentVNode("v-if", true),
            (
                    __props.collection.Settings?.alwaysExpanded != true &&
                    isUnlimited(__props.collection)
                )
              ? (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(_ctx.$style['show-more']),
                  key: "hide-all",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (stopShowAll(__props.collection)))
                }, _toDisplayString(_unref(labels).get(
                        "frontendProductList.filters.productCollection.showMore_close"
                    )), 3 /* TEXT, CLASS */))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ], undefined, true),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "enter-class", "leave-to-class", "leave-active-class"]))
}
}

})